import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { VUKZ } from '../../theme/vukzTheme';

/**
 * StudyFooter — Footer padrão para páginas de estudo
 *
 * Props:
 *   backLink  — URL para voltar (default: '/estudos')
 *   backLabel — Label do botão (default: 'Ver todos os estudos')
 */
const StudyFooter = ({
  backLink = '/estudos',
  backLabel = 'Ver todos os estudos',
}) => (
  <>
    <div className="mt-8 text-center">
      <Link
        to={backLink}
        className="inline-flex items-center gap-2 px-6 py-3 rounded-xl text-sm font-bold text-white hover:opacity-90 transition-opacity"
        style={{ backgroundColor: VUKZ.primary }}
      >
        <ArrowLeft className="w-4 h-4" /> {backLabel}
      </Link>
    </div>

    <div className="text-center py-6 border-t border-gray-200 mt-8 space-y-3">
      <div className="flex items-center justify-center gap-2">
        <img
          src="/microsoft-logo.png"
          alt="Microsoft for Startups"
          className="h-4 w-auto opacity-40"
          onError={(e) => { e.target.style.display = 'none'; }}
        />
        <p className="text-[10px] text-gray-400">
          Built with support from <span className="font-semibold">Microsoft for Startups</span>
        </p>
      </div>
      <p className="text-[10px] text-gray-300">
        VUKZ · Data Intelligence · Dados reais de competições
      </p>
    </div>
  </>
);

export default StudyFooter;
